module.exports = __webpack_public_path__ + "img/activity_h5.42b54cfd.png";